import { moduleStyleType } from 'components/no-ui/styles/styleTypes'

export const StructuredSearchStyles: moduleStyleType = {
    container: {
        display: 'flex',
        height: '90vh',
        flexDirection: 'column',
    },
    content: {
        display: 'flex',
        flexDirection: 'column',
        flex: 1,
        overflow: 'auto',
    },
    fitContent: {
        display: 'flex',
        flex: 1,
        flexDirection: 'column',
        overflow: 'hidden',
    },
    main: {
        padding: 4,
        borderRadius: '6px',
        border: '1px solid',
        borderColor: 'border.primary',
    },
    buttonContainer: {
        marginTop: 3,
    },
    queryInputsContainer: {
        marginTop: 2,
        marginBottom: 4,
    },
    queryContainer: {
        maxWidth: '32rem',
    },
    queryViewContainer: {
        mt: 3,
    },
    filterInputs: {
        mb: 3,
    },
    categoryHeader: {
        color: 'common.black',
        pb: 0,
    },
    downloadReportContainer: {
        display: 'flex',
        flex: 1,
        justifyContent: 'flex-end',
        alignItems: 'flex-end',
        height: '100%',
    },
    exportDataBox: {
        display: 'flex',
        justifyContent: 'flex-end',
        pt: 1,
    },
}
